import { render, staticRenderFns } from "./footerFixNav.vue?vue&type=template&id=71d0741a&scoped=true&"
import script from "./footerFixNav.vue?vue&type=script&lang=js&"
export * from "./footerFixNav.vue?vue&type=script&lang=js&"
import style0 from "./footerFixNav.vue?vue&type=style&index=0&id=71d0741a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d0741a",
  null
  
)

export default component.exports